import connection from "@sekizlipenguen/connection";
import moment from 'moment-timezone';
import HelperGeneral from "../helpers/HelperGeneral";
import UserInfo from "../main/auth/UserInfo";

const timezone = moment.tz.guess();
const timedifference = new Date().getTimezoneOffset();

connection.setConfig({timeout: 30000});

const Api = {
    apiUrl: function () {
        const url = window.location.host;
        if (url.indexOf('127.0.0.1') !== -1 || url.indexOf('-test') !== -1 || url.indexOf('localhost') !== -1) {
            return process.env.REACT_APP_API_TEST_URL;
        } else {
            return process.env.REACT_APP_API_URL;
        }
    },
    tokenControl: function (token) {
        let newTokenGet = false;
        if (!UserInfo.info()) {
            UserInfo.logout2();
        } else {
            const dt = new Date();
            const timestamp = Math.floor(dt.getTime() / 1000);
            let expires_start = token.expires_start - 1000;
            if (timestamp >= expires_start) {
                UserInfo.logout();
                newTokenGet = true;
            }
        }
        return newTokenGet;
    },
    uuidv4: function (reset = false) {
        let uniqid = localStorage.getItem('uniqid');
        if (!uniqid || reset) {
            uniqid = HelperGeneral.uuidv4();
            localStorage.setItem('uniqid', uniqid);
        }
        return uniqid;
    },
    getHeaderToken: async function (type = 1, companyId = null) {
        const apiUrl = Api.apiUrl();
        const uuidv4 = Api.uuidv4();
        let tokenInfo = localStorage.getItem('userToken');
        tokenInfo = JSON.parse(tokenInfo);
        return new Promise((resolve, reject) => {
            const result = {
                'Access-Control-Allow-Origin': '*',
                Accept: 'application/json',
                'Content-Type': type === 1 ? 'application/json; charset=utf-8' : 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2),
                TimeZone: timezone,
                TimeZoneOffset: timedifference,
                Os: navigator.platform.toLowerCase(),
                Locale: navigator.language || navigator.userLanguage,
                Channel: '1page_portal',
                'Order-Type': 'self'
            };

            if (tokenInfo) {
                Api.tokenControl(tokenInfo);
                result.Authorization = tokenInfo?.type + ' '.concat(tokenInfo?.token);
            }

            if (companyId) {
                result['Company-Id'] = companyId;
            }

            result.ApiUrl = apiUrl;
            result.uniqid = uuidv4;
            resolve(result);
        });
    },
    errorCheck(e, reject) {
        if (e?.data?.message === 'Unauthenticated.') {
            UserInfo.logout2();
            HelperGeneral.alert('Oturumunuz sonlandırıldı!', 'error');
            setTimeout(() => {
                window.location.href = '/Login';
            }, 2000);
        } else {
            return reject(e);
        }
    },
    getCustomer() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'user/getAllInfo', {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    customerLogin(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'auth/loginSend', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    createContactOtp(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'smsSend/' + headers?.uniqid, data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    verifyOtp(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'isVerification/' + headers.uniqid, data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    customerCreate(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'user/registerSend/' + headers.uniqid, data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    updatePassword(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'user/passwordSave/' + headers.uniqid, data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    changePassword(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'user/profilePasswordSave/' + headers.uniqid, data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    userCreate(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken(1, data?.company_id).then(headers => {
                connection.post(Api.apiUrl() + 'partner/user?type=company_contact', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getAllBanner() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'slider', {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getTransactions(page = 1, size = 10) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'v2/user/point-code/history?sort=-used_at&page[number]=' + page + '&page[size]=' + size, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    transactionAdd(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'v2/user/point-code/use', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getProducts(slug, page = 1, size = 10) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'getProduct/v2/' + headers?.uniqid + '?slug=' + encodeURIComponent(slug) + '&r=json&page=' + page + '&size=' + size, [], {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getProductDetail(product_id) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'product/v2/' + product_id + '/' + headers?.uniqid + '?r=json', {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getCategoryWithSubCategories() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'getCategories', {headers: headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    productSearch(keyword = '') {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'getProduct/v2/' + headers?.uniqid + '?r=json&page=1&size=5&order_by=name&q=' + keyword, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getCitiesAll() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'getCities', {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => this.errorCheck(e, reject));
        });
    },
    getCounties(cityId) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'getCounty/' + cityId, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getPharmacies(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'getShippingStoreSearch', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    addressAddOrCreate(data) {
        return new Promise((resolve, reject) => {
            if (data && data.country_id === undefined && data.country !== undefined) {
                data.country_id = data.country;
            }
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'userAddressSave/' + headers?.uniqid, data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    addressDelete(addressId) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.delete(Api.apiUrl() + 'userAddressDelete/' + headers?.uniqid + '/' + addressId, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getAddressAll() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'getAddresses/' + headers?.uniqid, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getBasket() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken(1).then((headers) => {
                connection.get(Api.apiUrl() + 'getBasket/' + headers?.uniqid, {headers: headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    addBasket(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken(1).then((headers) => {
                connection.post(Api.apiUrl() + 'addBasket', data, {headers: headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    updateBasket() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken(1).then((headers) => {
                const data = {
                    quantity: [0],
                };
                connection.post(Api.apiUrl() + 'getBasket/' + headers.uniqid, data, {headers: headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => this.errorCheck(e, reject));
        });
    },
    getPaymentMethods() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then((headers) => {
                connection.get(Api.apiUrl() + 'partner/payment', {headers: headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    createOrder(paymentId = null, products = [], addresses = [], selectedAddressId = null, selectedInvoiceAddressId = null, isInvoiceAddressSame = true) {
        return new Promise((resolve, reject) => {
            const selectedAddress = addresses?.find(addr => addr?.id === selectedAddressId);
            const selectedInvoiceAddress = !isInvoiceAddressSame ? addresses?.find(addr => addr?.id === selectedInvoiceAddressId) : null;

            let data = {
                payment_methods: paymentId,
                paymentArea: 'true',
                user_first_name: selectedAddress?.name,
                user_last_name: selectedAddress?.last_name,
                user_telephone: selectedAddress?.telephone,
                user_email: selectedAddress?.email,
                delivery_name: selectedAddress?.title,
                delivery_telephone: selectedAddress?.telephone,
                sync_address: isInvoiceAddressSame ? 'on' : 'off',
                paymentPageDeliveryDate: '0',
                uniqid: Api.uuidv4(),
                tc_citizen: 0,
                user_address: selectedAddress?.address,
                shipping_methods: 3,
                delivery_address_id: selectedAddressId,
                invoice_address_id: isInvoiceAddressSame ? selectedAddressId : selectedInvoiceAddressId,
                invoice_first_name: isInvoiceAddressSame ? (selectedAddress?.name) : (selectedInvoiceAddress?.name),
                invoice_last_name: isInvoiceAddressSame ? (selectedAddress?.last_name) : (selectedInvoiceAddress?.last_name),
                invoice_telephone: isInvoiceAddressSame ? (selectedAddress?.telephone) : (selectedInvoiceAddress?.telephone),
                invoice_email: isInvoiceAddressSame ? (selectedAddress?.email) : (selectedInvoiceAddress?.email),
                invoice_address: isInvoiceAddressSame ? (selectedAddress?.address) : (selectedInvoiceAddress?.address),
                invoice_city_id: isInvoiceAddressSame ? selectedAddress?.city_id : selectedInvoiceAddress?.city_id,
                invoice_county_id: isInvoiceAddressSame ? selectedAddress?.county_id : selectedInvoiceAddress?.county_id,
                gift_address: 'on',
                gift_user_name: 'Yusuf Cemal Gültekin',
            };

            if (products?.length > 0) {
                data.quantity = products?.map(product => product?.quantity || 0);
                data.gift_product = products?.map(product => product?.quantity || 0);
            }

            Api.getHeaderToken(1).then((headers) => {
                connection.post(Api.apiUrl() + 'getBasket/' + headers?.uniqid, data, {headers: headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    createCommunication(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'v2/user/form/submit', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getOrders() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'v2/user/order?type=self&sort=-created_at&page[number]=1&page[size]=100', {headers}).then(r => resolve(r)).catch(e => reject(e));
            }).catch(e => this.errorCheck(e, reject));
        });
    },
    getPharmacyGetContacts(page, size) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'v2/user/company?type=company_contact&sort=-created_at&page[number]=' + page + '&page[size]=' + size, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getCompany(id) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'v2/user/company/' + id, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    userEmailUpdate(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'user/email-change', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    userTelephoneUpdate(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.post(Api.apiUrl() + 'user/gsmChange', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    contactPreferences(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.put(Api.apiUrl() + 'user/permissions', data, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    contactDelete(data) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.delete(Api.apiUrl() + 'user', {data}, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getDocuments(channel, categoryId) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'blog?filter[channels]=' + channel + (categoryId ? '&filter[category_id]=' + categoryId : ''), {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getCategoryList(channel) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'blog/category?filter[channels]=' + channel, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getTop5(type = 'self', company_id = null) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'v2/user/product/top-points?type=' + type + (company_id ? 'company_id=' + company_id : '') + '=&sort=-total_earned_points&page[number]=1&page[size]=5&source=point_codes', {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    bestSeller() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'v2/user/product/best-selling?type=all&sort=-total_quantity&page[number]=1&page[size]=5', {headers: headers}).then(r => resolve(r)).catch(e => reject(e));
            }).catch(e => reject(e));
        });
    },
    getOtherPages() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'getOtherPages', {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    getPriceList() {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'partner/price-list/by-uuid-and-code?uuid=D9ECCAC0-051B-F1A2-2206-0CCF8E424529&code=FOM-H47-QMH-OGIR', {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    },
    // Faz 2
    // getQrDetail(qrCode, customerType) {
    //     return new Promise((resolve, reject) => {
    //         Api.getHeaderToken().then(headers => {
    //             connection.get(Api.apiUrl() + 'product/getQrDetail/' + qrCode + '/' + customerType, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
    //         }).catch(e => reject(e));
    //     });
    // },
    getPointCodeDetailPage(code) {
        return new Promise((resolve, reject) => {
            Api.getHeaderToken().then(headers => {
                connection.get(Api.apiUrl() + 'v2/public/point-code/info?code=' + code, {headers}).then(r => resolve(r)).catch(e => this.errorCheck(e, reject));
            }).catch(e => reject(e));
        });
    }
};

export default Api;
